import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

import { useLocation, useNavigate } from "react-router-dom";
import { useAdminContext } from "../../context/adminContext";
import Modal from "../../components/modal/modal";
import Pagination from "../../components/pagination/pagination";
import TableLoading from "../../components/tableLoading/TableLoading";
import DraggableTable from "../../components/draggableTable/draggableTable";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { deleteByIdApi, getAllApi } from "../../api";
import Table from "../../components/table/table";

const Blogs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [total, setTotal] = useState(0);
  const [modal, setModal] = useState(false);
  const [inFocus, setInFocus] = useState("");
  const [index1, setIndex1] = useState(0);
  const [index2, setIndex2] = useState(0);
  const [delId, setDelId] = useState("");

  const { admin } = useAdminContext();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    getAllApi("article")
      .then((response) => {
        setBlogs(
          response.data.map((val) => ({
            ...val,
            live_link: `https://girnarsoft-web.vercel.app/insight/${val.metaData.slug}`,
            ct: val?.createdAt
              ? val?.createdAt.split("T")[0].split("-").reverse().join("/")
              : "",
          }))
        );
        console.log(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setBlogs([]);
        setLoading(false);
        toast.error("Something went wrong while fetching blogs.");
      });
  };

  const handleSwap = (id1, id2, priority1, priority2) => {
    if (admin?.role === "subadmin" && !admin?.blog_access?.write) {
      toast.error("You don't have permission to perform this action.");
      return;
    }
    let temp = [...blogs];
    let newIndex1 = temp.findIndex((val) => val.id === id1);
    let newIndex2 = temp.findIndex((val) => val.id === id2);

    setIndex1(newIndex1);
    setIndex2(newIndex2);

    if (priority1 > priority2) {
      temp[newIndex1].priority = priority2;
      for (let i = newIndex2; i < newIndex1; i++) {
        temp[i].priority = temp[i].priority + 1;
      }
    }

    if (priority2 > priority1) {
      temp[newIndex1].priority = priority2;
      for (let i = newIndex1 + 1; i < newIndex2 + 1; i++) {
        temp[i].priority = temp[i].priority - 1;
      }
    }
    console.log(
      temp.map((val) => ({
        ...val,
        live_link: `https://girnarsoft-web.vercel.app/insight/${val.metaData.slug}`,
      }))
    );
    setBlogs(
      temp.map((val) => ({
        ...val,
        live_link: `https://girnarsoft-web.vercel.app/insight/${val.metaData.slug}`,
      }))
    );
    setLoading(true);
    updateForSwap();
  };

  const updateForSwap = async () => {
    if (index1 > index2) {
      for (let i = index2; i < index1 + 1; i++) {
        // api call to updated sequence
        // await callApi({
        //   method: "patch",
        //   data: { priority: blogs[i]?.priority },
        //   url: blogs[i]?.id,
        //   type: "blogs",
        //   header: true,
        // });
      }
    }

    if (index2 > index1) {
      for (let i = index1; i < index2 + 1; i++) {
        // await callApi({
        //   url: blogs[i].id,
        //   data: { priority: blogs[i].priority },
        //   method: "patch",
        //   type: "blogs",
        //   header: true,
        //   identifier: true,
        // });
      }
    }

    getData();
  };

  const handleDelete = () => {
    setModal(false);
    setLoading(true);
    const promise = new Promise((resolve, reject) => {
      deleteByIdApi("article", inFocus)
        .then((res) => {
          setInFocus("");
          setLoading(false);
          resolve(true);
        })
        .catch((err) => {
          reject();
        });
    });

    toast
      .promise(
        promise,
        {
          loading: "Deleting...",
          success: "Deleted Successfully.",
          error: "Error when deleting the entry.",
        },
        { success: { duration: 2000 }, error: { duration: 2000 } }
      )
      .then(() => {
        getData();
      });
  };

  const handleAction = (val, id) => {
    if (val === "delete") {
      setModal(true);
      setInFocus(id);
    }

    if (val === "archive" || val === "unarchive") {
      const status = val === "archive" ? "draft" : "live";

      const promise = new Promise((resolve, reject) => {
        // callApi({
        //   method: "patch",
        //   data: { status },
        //   url: id,
        //   type: "blogs",
        //   header: true,
        // })
        //   .then((res) => {
        //     resolve(true);
        //   })
        //   .catch(() => {
        //     reject();
        //   });
      });

      const actionText = val === "archive" ? "Archiving" : "UnArchiving";

      toast
        .promise(
          promise,
          {
            loading: `${actionText}...`,
            success: `${actionText} Successfully.`,
            error: `Error when ${actionText.toLowerCase()} the entry.`,
          },
          { success: { duration: 2000 }, error: { duration: 2000 } }
        )
        .then(() => {
          getData();
        });
    }
  };

  return (
    <>
      <Modal
        title={"Delete"}
        description={
          "Do you really want to delete this record? This process cannot be undone."
        }
        onBtn1Click={() => setModal(false)}
        onBtn2Click={handleDelete}
        state={modal}
      />
      <Content>
        <ContentHead
          title={"blogs"}
          showBtn1={
            admin?.role === "subadmin" ? admin?.blog_access.write : true
          }
          btn1Name="btn1"
          btn1Text={"New Blog"}
          btn1type="filled"
          onClickHandler={() => {
            navigate("/blogs/add");
          }}
          customElement={<></>}
        />
        <ContentBody style={{ padding: 0 }}>
          {loading ? (
            <TableLoading
              head={["S.No.", "Blog Title", "Status", "createdAt"]}
            />
          ) : (
            <Table
              head={[
                { title: "S.No." },
                { title: "Blog Title" },
                { title: "Status" },
                { title: "Created At" },
                { title: "" },
                { title: "" },
              ]}
              body={[...blogs]}
              body_keys={[
                "blogTitle",
                "status",
                "ct",
                "live_link",
                "action:delete",
              ]}
              number={true}
              onRowClick={(e) => {
                navigate("/blogs/" + e._id);
              }}
              onActionClick={(i, val) => {
                setInFocus(val);
                setModal(true);
              }}
            />
            // <DraggableTable
            //   head={["S.No.", "Blog Title", "Status", ""]}
            //   body={[...blogs]}
            //   body_keys={["sno", "blogTitle", "status", "action"]}
            //   onSwap={handleSwap}
            //   onDelete={(val, id) => {
            //     setInFocus(id);
            //     handleAction("delete", id);
            //   }}
            //   onEdit={(id) => {
            //     navigate("/blogs/" + id);
            //   }}
            //   pageNo={pageNo - 1}
            // />
          )}
        </ContentBody>
      </Content>
    </>
  );
};

export default Blogs;
